import React from "react";

interface ProgressProps {
    progress : number;
    hex_color : string;
}

const ProgressBar : React.FC<ProgressProps> = ({ progress, hex_color }) => {
    return (
      <div className="w-full bg-gray-200 rounded-full h-8">
        <div
          className="h-8 rounded-full transition-all border-2 border-white duration-300"
          style={{ width: `${progress}%`, backgroundColor : hex_color}}
        ></div>
      </div>
    );
};

export default ProgressBar;